import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import Header from "../../components/Header";
import RadioItem from "../../components/RadioItem";
import ThreeTabConfigItem from "./components/ThreeTabConfigItem";
import Firebase from "../../firebasehelper";
import {
  default_menus,
  titles,
  threeTabBarOneValues,
  threeTabBarTwoValues,
} from "./constants/default";
import "./index.css";

const BespokeExplore = () => {
  const history = useHistory();
  const location = useLocation();
  const [brand_data, setBrandData] = useState({});
  const [brand, setBrand] = useState(null);
  const [role, setRole] = useState(null);
  const [username, setUserName] = useState("");
  const [loading, setLoading] = useState(false);
  const [lightUserUpgrade, setLightUserUpgrade] = useState(true);
  useEffect(() => {
    if (!location.state) {
      history.push("/");
    } else {
      const { brand, role, username } = location.state;
      setBrand(brand);
      setRole(role);
      setUserName(username);
      setLoading(true);
      Firebase.getBrandDataByID(brand, (brand_data) => {
        if (brand_data) {
          setLoading(false);
          setLightUserUpgrade(
            brand_data.menus
              ? brand_data.menus.lightUserUpgrade === undefined
                ? true
                : brand_data.menus.lightUserUpgrade
              : true
          );
          //menu initialization:
          let menus = { ...default_menus };
          if (brand_data.menus) {
            Object.keys(menus).forEach(
              (key) =>
                (menus[key] =
                  brand_data.menus[key] === undefined
                    ? menus[key]
                    : brand_data.menus[key])
            );
          }
          brand_data.menus = menus;
          setBrandData(brand_data);
        }
      });
    }
  }, [location]);
  /* starting of handler part */

  const handleChangeConfig = (tabBar) => async (value) => {
    await Firebase.updateBrandDataById(brand, { [tabBar]: value });
  };

  const handleYes = (menu) => async () => {
    // let menus = brand_data.menus ? brand_data.menus : default_menus;
    brand_data.menus[menu] = true;
    await Firebase.updateBrandDataById(brand, {
      menus: { ...brand_data.menus, lightUserUpgrade: lightUserUpgrade },
    });
  };

  const handleNo = (menu) => async () => {
    // let menus = brand_data.menus ? brand_data.menus : default_menus;
    brand_data.menus[menu] = false;
    await Firebase.updateBrandDataById(brand, {
      menus: { ...brand_data.menus, lightUserUpgrade: lightUserUpgrade },
    });
  };
  /* ending of handler part */
  const renderMenus = () => {
    let menus = brand_data.menus ? brand_data.menus : default_menus;
    menus = JSON.parse(JSON.stringify(menus, Object.keys(default_menus)));
    return Object.keys(menus).map((key) => (
      <RadioItem
        menuName={titles[key]}
        checked={menus[key]}
        onYes={handleYes(key)}
        onNo={handleNo(key)}
      />
    ));
  };
  return (
    <div id="page-container" className="bespoke-explore-container">
      <Header
        username={username}
        role={role}
        logo={brand_data.logo}
        brand={brand}
        brandName={brand_data.name}
        is_property_brand={brand_data.is_property_brand}
      />
      <main id="main-container">
        <div className="bespoke-explore-content">
          {loading && (
            <div className="loading">
              <i className="fa fa-4x fa-sync fa-spin text-muted" />
            </div>
          )}
          {!loading && (
            <React.Fragment>
              <div className="left-content">{renderMenus()}</div>
              <div className="right-content">
                <ThreeTabConfigItem
                  threeTabBarName="3 tab bar one"
                  initial={
                    brand_data.threeOne
                      ? brand_data.threeOne
                      : threeTabBarOneValues
                  }
                  onChangeConfig={handleChangeConfig("threeOne")}
                />
                <ThreeTabConfigItem
                  threeTabBarName="3 tab bar two"
                  initial={
                    brand_data.threeTwo
                      ? brand_data.threeTwo
                      : threeTabBarTwoValues
                  }
                  onChangeConfig={handleChangeConfig("threeTwo")}
                />
              </div>
            </React.Fragment>
          )}
        </div>
      </main>
    </div>
  );
};

export default BespokeExplore;



// WEBPACK FOOTER //
// ./src/screens/BespokeExplore/index.js